﻿import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProviderDto } from 'src/app/dtos/provider-dto';
import { MessageService } from 'src/app/core/services/message.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { AddressControlComponent } from 'src/app/shared/address-control/address-control.component';
import { ApiService } from '../../../../core/services/api.service';

@Component({
    selector: 'providers-add',
    templateUrl: './providers-add.component.html',
    styleUrls: ['./providers-add.component.scss']
})
/** providers-add component*/
export class ProvidersAddComponent implements OnInit{
    form: FormGroup;
  submitted: boolean;
  id: any;
  provider: ProviderDto;
  isEditing: boolean;
  submitButtonText: string = 'GENERAL.LABELS.CREATE';
  @ViewChild("addressControl") addressControl: AddressControlComponent;

  constructor(private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private apiService: ApiService,
    private messageService: MessageService, private location: Location) {
    this.id = this.activatedRoute.snapshot.params['id'];
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      rfc: ['', Validators.required],
      bank: [''],
      account: ['', Validators.required],
      clabe: ['', Validators.required],
      activity: ['', Validators.required],
      certification: ['', Validators.required],
      telephone: ['', [Validators.required, Validators.minLength(6)]],
      email: ['', [Validators.required, Validators.email]]
    });

    if (this.id) {
      this.isEditing = true;
      this.submitButtonText = 'GENERAL.LABELS.EDIT';

      this.apiService.get('api/provider/dto/' + this.id).subscribe((data: any) => {
        this.provider = data.data;
        this.form = this.formBuilder.group({
            name: [this.provider.name, Validators.required],
            rfc: [this.provider.rfc, Validators.required],
            bank: [this.provider.bank, Validators.required],
            account: [this.provider.account, Validators.required],
            clabe: [this.provider.clabe, Validators.required],
            activity: [this.provider.activity, Validators.required],
            certification: [this.provider.certification, Validators.required],
            telephone: [this.provider.telephone, [Validators.required, Validators.minLength(6)]],
            email: [this.provider.email, [Validators.required, Validators.email]]
        });
        this.addressControl.setAddressData(this.provider);
      });

    }
  }

  get controls() { return this.form.controls; }

  back() {
    this.location.back();
  }

  onSubmit() {
    this.submitted = true;

    let addressControlData = this.addressControl.getAddressData();
    if (this.form.invalid || addressControlData.isInvalid) {
      return;
    }

    let client: ProviderDto = this.form.value as ProviderDto;
    let address: ProviderDto = addressControlData.values as ProviderDto;

    let model = Object.assign({}, client, address);

    if (!model.intNumber)
      model.intNumber = 0;

    if (this.isEditing) {
      model.id = this.id;
      this.apiService.put('api/provider/updateFromDto', model).subscribe(() => {
        this.messageService.success("Exito", "El proveedor se ha actualizado exitosamente.");
        this.location.back();
      });
    }
    else {
      this.apiService.post('api/provider/saveFromDto', model).subscribe(() => {
        this.messageService.success("Exito", "El proveedor se ha agregado exitosamente.");
        this.location.back();
      });
    }
  }
}